// timeline event types for the live day-trade bot — mirrors BotEventType but covers
// both legs (buy + sell) and the advisory-signal / confirmed-fill execution path
export enum DayTradeBotEventType {
  SESSION_STARTED = 'SESSION_STARTED',
  SESSION_STOPPED = 'SESSION_STOPPED',
  SIGNAL_BUY = 'SIGNAL_BUY',
  SIGNAL_SELL = 'SIGNAL_SELL',
  ORDER_PLACED = 'ORDER_PLACED',
  ORDER_FILLED = 'ORDER_FILLED',
  ORDER_PARTIAL = 'ORDER_PARTIAL',
  ORDER_REJECTED = 'ORDER_REJECTED',
  ORDER_CANCELLED_EXT = 'ORDER_CANCELLED_EXT',
  ORDER_ROLLBACK = 'ORDER_ROLLBACK',
  // a resting in-flight order was cancelled by the reconcile loop after exceeding its TTL,
  // freeing the engine's in-flight lock so it can act on the next tick
  ORDER_TIMED_OUT = 'ORDER_TIMED_OUT',
  // an instrument could not be armed because the broker account already holds a position
  START_GUARD_BLOCKED = 'START_GUARD_BLOCKED',
  DAILY_RESET = 'DAILY_RESET',
  EOD_LIQUIDATION = 'EOD_LIQUIDATION',
  CONFIG_UPDATED = 'CONFIG_UPDATED',
  // sell-only wind-down was turned on/off for a session (buy leg blocked / restored); ENABLED
  // also cancels any resting buy order so a queued buy can't fill after the user asks to stop
  SELL_ONLY_ENABLED = 'SELL_ONLY_ENABLED',
  SELL_ONLY_DISABLED = 'SELL_ONLY_DISABLED',
  // the snapshot was recomputed from broker reality (position + order history) via the
  // debug-page resync action
  SNAPSHOT_RESYNCED = 'SNAPSHOT_RESYNCED',
  // the stream-manager trading-status gate suppressed ticks because the instrument is not
  // in normal trading (or the status is unknown); recorded once per closure, not per tick
  TICK_SUPPRESSED_MARKET_CLOSED = 'TICK_SUPPRESSED_MARKET_CLOSED',
  ERROR = 'ERROR',
}
